import en from './en'
import de from './de'

export default {
  locale: 'de',
  messages: {
    en,
    de
  }
}
